import { MenuOutlined } from '@ant-design/icons';
import {
  Typography,
} from 'antd';
import React, { useState } from 'react';
import Menu from '../sideMenu/Menu';
import styles from '../styles.module.scss';
import AppBar from './AppBar';

const { Title } = Typography;

const MobileHeader = ({ isProd }) => {
  const [menuDropdownOpen, setMenuDropdownOpen] = useState(false);

  return (
    <div className={styles.mobileHeader} style={{ backgroundColor: isProd ? 'var(--prod-color)' : 'var(--non-prod-color)' }}>
      <a href="/" style={{ color: 'inherit', textDecoration: 'none' }}>
        <Title
          strong
          style={{
            background: 'linear-gradient(45deg, var(--contrast-color), #F47560)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
            color: 'transparent', // Fallback for browsers that don't support background-clip
            marginBottom: '0rem',
          }}
          className={styles.mobileHeaderTitle}
        >
          IOTA
        </Title>
      </a>
      <div className={styles.menuDropdown}>
        <MenuOutlined onClick={() => setMenuDropdownOpen(!menuDropdownOpen)} style={{ color: 'white', fontSize: '20px' }} />
        {menuDropdownOpen && (
        <div className={styles.menuDropdownContent} style={{ backgroundColor: isProd ? 'var(--prod-color)' : 'var(--non-prod-color)' }}>
          <Menu asDropdown closeMenu={() => setMenuDropdownOpen(false)} />
          <AppBar isProd={isProd} asMobile closeMenu={() => setMenuDropdownOpen(false)} />
        </div>
        )}
      </div>
    </div>
  );
};

export default MobileHeader;
